import { ApplicationState } from "state/ducks";
import { SupportedLocales } from "./configureI18n";

export const getCurrentLocale = (state: ApplicationState): SupportedLocales => state.i18n.locale;